import { WALLET_TYPE } from "../shared/wallet-types";
import { z } from "zod";

export const TransferRoutesSchema = z.partialRecord(z.enum(WALLET_TYPE), z.array(z.enum(WALLET_TYPE)));
export type TransferRoutes = z.infer<typeof TransferRoutesSchema>;

export const TransferInternalResponseSchema = z.object({
  id: z.string(),
});
export type TransferInternalResponse = z.infer<typeof TransferInternalResponseSchema>;
